/* Version: 3.5.137 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import styled, { ThemeProvider as ThemeProvider$1 } from 'styled-components';
import canadianTheme from './canadianTheme.js';
import { jsx } from 'react/jsx-runtime';
import cssTokens from '../utils/cssTokens.js';

var _excluded = ["children"];
var CssTokensProvider = /*#__PURE__*/styled.div.withConfig({
  displayName: "ThemeProvider__CssTokensProvider",
  componentId: "sc-1h00wj1-0"
})(["", ""], function (_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === undefined ? canadianTheme : _ref$theme;
  var tokens = cssTokens(theme);
  return Object.keys(tokens).map(function (key) {
    return "".concat(key, ": ").concat(tokens[key], ";");
  });
});

/**
 * This provider wraps the `ThemeProvider` from styled-components, and provides various tokens
 * from the theme as CSS variables that are necessary for making custom themes work.
 */
var ThemeProvider = function ThemeProvider(_ref2) {
  var children = _ref2.children,
    rest = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/jsx(ThemeProvider$1, _objectSpread(_objectSpread({}, rest), {}, {
    children: /*#__PURE__*/jsx(CssTokensProvider, {
      children: children
    })
  }));
};

export { ThemeProvider as default };
